import React, { useState } from 'react'

export const ChangeNameModal = ({
  ticket,
  closeModalHandler,
  changeName
}) => {
  const [fullName, setFullName] = useState('');

  const changeInputData = (value) => {
    setFullName(value);
  };

  return (
    <>
      <h2 className="swal2-title">
        Change ticket holder name
      </h2>

      <input
        className="swal2-input"
        type="text"
        name="name"
        value={fullName}
        placeholder={'Current full name: ' + ticket.fullName}
        minLength="3"
        maxLength="500"
        onChange={({target}) => changeInputData(target.value)}
      />

      <div className="swal2-actions">
        <button
          className="swal2-cancel swal2-styled"
          onClick={closeModalHandler}
        >
          Cancel
        </button>
        <button
          className="swal2-confirm swal2-styled btn-primary"
          onClick={() => changeName(ticket, fullName)}
          disabled={ticket.fullName === fullName || !fullName}
        >
          Change
        </button>
      </div>
    </>
  )
}
